import gql from "graphql-tag"

import UserOnboarding from "../fragments/userOnboarding"

const mutation = gql`
  mutation removeUserOnboardingStep($userId: String!, $stepId: String!) {
    removeUserOnboardingStep(userId: $userId, stepId: $stepId) {
      ...UserOnboarding
    }
  }
  ${UserOnboarding}
`

export default mutation
